
import { Component, Vue } from 'vue-property-decorator'
import { Options } from '../@types/Slide'

@Component
export default class HeightAndWidth extends Vue {
  public width: number = 0
  public height: number = 0
  /**
   * Get current context.
   */
  get context() {
    return this.canvas.getContext('2d')
  }
  /**
   * Get canvas.
   */
  get canvas() {
    return (this.$refs.canvas || this.$el) as HTMLCanvasElement
  }
  /**
   * Set width and height.
   */
  public setWidthAndHeight() {
    this.width = this.canvas.getBoundingClientRect().width
    this.height = this.canvas.getBoundingClientRect().height
  }
  /**
   * Mounted hook.
   */
  mounted() {
    window.addEventListener('resize', this.setWidthAndHeight.bind(this))
    this.setWidthAndHeight()
  }
}
